import React, { useState, useEffect } from 'react';
import StyledBox from 'views/information-module/ReBrandingView/ReBrandingView.styles';
import { useTranslation } from 'next-i18next';
import {
  FranchiseCommonSections,
  StyledFranchiseTitleWithDesc,
} from 'views/information-module/common/components';
import { Box } from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';

const rebrandingImage = {
  src: '/imgs/franchise/RE-BRANDIN.jpg',
  alt: 'Franchise Re-Branding',
};
const inquiryLink = 'https://docs.google.com/forms/d/1AF2DrjrnVam5RqxBqlETEnOt9btUjTY_sMN38LRnVpA/viewform?edit_requested=true';

const ReBrandingView = (props) => {
  const { t } = useTranslation('fe_er_re_branding_page');
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };
  const verticaltabs = [
    {
      label: t('fe_er_re_branding_page:key_benefits_header'),
      value: 1,
      href: '#benefits',
    },
    {
      label: t('fe_er_re_branding_page:requirments_header'),
      value: 2,
      href: '#requirements',
    },
  ];

  const activeTab = 5;
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);
  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>
      <StyledBox>
        <FranchiseCommonSections
          activeTab={activeTab}
          verticaltabs={verticaltabs}
          titleWithImage={rebrandingImage}
          titleWithImgText={t('fe_er_re_branding_page:header')}>
          <Box mb={2} id="benefits">
            <Typography500 variant="h3" component="h2" mb={2}>
              {t('fe_er_re_branding_page:key_benefits_header')}
            </Typography500>
            <StyledFranchiseTitleWithDesc
              description={t('fe_er_re_branding_page:key_benefits_text')}
            />
          </Box>
          <Box className="RBBenefit">
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_re_branding_page:benefits_include_header')}
              description={t('fe_er_re_branding_page:benefits_include_text', {
                inquiry_link: inquiryLink,
              })}
            />
          </Box>
          <Box
            mt={{ lg: 11, md: 8, sm: 6 }}
            mb={5}
            className="RBReq"
            id="requirements">
            <Typography500 variant="h3" component="h2" mb={2}>
              {t('fe_er_re_branding_page:requirments_header')}
            </Typography500>
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_re_branding_page:rebrand_easy_header')}
              description={t('fe_er_re_branding_page:rebrand_easy_text', {
                inquiry_link: inquiryLink,
              })}
            />
          </Box>
        </FranchiseCommonSections>
      </StyledBox>
    </>
  );
};

export { ReBrandingView };
